import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 4A3863FA-620C-4564-8A7B-57681117B81D
 * name grid-large
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/grid-large.svg
 * tags
 */
export const GridLargeIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4C2.92,22 2,21.1 2,20V4A2,2 0 0,1 4,2M4,4V11H11V4H4M4,20H11V13H4V20M20,20V13H13V20H20M20,4H13V11H20V4Z" /></>, 'GridLargeIcon');
export default GridLargeIcon